import React, { useMemo, useState } from 'react';
import projects, { FILTERS } from '../data/projects';
import ProjectCard from './ProjectCard';

export default function Projects() {
  const [filter, setFilter] = useState('All');

  const shown = useMemo(() => {
    const live = projects.filter((p) => p.variant !== 'wip');
    if (filter === 'All') return live;
    return live.filter((p) => p.tags.includes(filter));
  }, [filter]);

  const featured = shown.filter((p) => p.variant === 'featured');
  const standard = shown.filter((p) => p.variant !== 'featured');
  const wips = projects.filter((p) => p.variant === 'wip');

  return (
    <section id="projects" className="projects" aria-labelledby="projects-title">
      <div className="section-head fade-in">
        <h2 className="section-title" id="projects-title">
          Projects
        </h2>
        <p className="section-lead">
          Hackathon wins, research, and shipped apps — the through-line is building
          things people can actually use.
        </p>
      </div>

      <div className="filter-row fade-in" role="group" aria-label="Filter projects by focus">
        {FILTERS.map((f, i) => (
          <button
            key={f}
            type="button"
            aria-pressed={filter === f}
            className={`filter-chip ${filter === f ? 'is-active' : ''}`}
            style={{ '--i': i }}
            onClick={() => setFilter(f)}
          >
            {f}
          </button>
        ))}
      </div>

      {shown.length === 0 ? (
        <p className="projects-empty fade-in" role="status">
          Nothing tagged “{filter}” yet — try another filter.
        </p>
      ) : null}

      {featured.length > 0 && (
        <div className="project-featured-list">
          {featured.map((p, i) => (
            <ProjectCard key={p.id} project={p} index={i} />
          ))}
        </div>
      )}

      {standard.length > 0 && (
        <div className="project-grid">
          {standard.map((p, i) => (
            <ProjectCard key={p.id} project={p} index={i} />
          ))}
        </div>
      )}

      {wips.length > 0 && (
        <div className="wip-block fade-in">
          <h3 className="wip-heading">Works in progress</h3>
          <div className="wip-grid">
            {wips.map((p, i) => (
              <ProjectCard key={p.id} project={p} index={i} />
            ))}
          </div>
        </div>
      )}
    </section>
  );
}
